import script from "./FormAgentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormAgentComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormAgentComponent.vue?vue&type=style&index=0&id=4fa517db&scoped=true&lang=css"
import "./FormAgentComponent.vue?vue&type=style&index=1&id=4fa517db&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa517db"]])

export default __exports__